<script setup>

import emitter from '@/util/emitter.js'
import { onMounted, onBeforeUnmount } from 'vue'
import { ElMessage } from 'element-plus'


const handleHttpError = (event) => {
  ElMessage({
    message: event.message,
    grouping: true,
    type: 'error'
  })
  // if (event.code === 4010) {
  //   // Token 过期重载页面
  //   window.location.reload()
  // }
}

onMounted(() => {
  emitter.on('http-error', handleHttpError)
})

onBeforeUnmount(() => {
  emitter.off('http-error', handleHttpError)
})
</script>

<template>
  <!-- 组件本身无需渲染任何内容 -->
  <div style="display: none" />
</template>

<style scoped lang="scss">

</style>
